import * as ReselectModule from "reselect";
import { IClientListState } from ".";
import { IApplicationState } from "..";

export const selectClientList: ReselectModule.Selector<
  IApplicationState,
  IClientListState
> = (state) => state.clientList;
